export default __webpack_public_path__ + "static/media/Vax-Track-1.b99f9a57.jpg";